import { render, staticRenderFns } from "./EditLogo.vue?vue&type=template&id=dddc80de&scoped=true"
import script from "./EditLogo.vue?vue&type=script&lang=js"
export * from "./EditLogo.vue?vue&type=script&lang=js"
import style0 from "./EditLogo.vue?vue&type=style&index=0&id=dddc80de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddc80de",
  null
  
)

export default component.exports